import config from "../config/index";
const cookies = require("js-cookie");

// Single place that tears down the auth cookies. They are set with a domain
// (config.cookiedomain), and js-cookie can only delete a cookie when remove() is
// given the SAME domain (+ path). Without it the dead, domain-scoped cookies
// survive, isLoggedIn() keeps returning true, and the app re-uses an invalid
// session — the root cause of the "redirect loop until browser restart" bug.
// See ADR-0013.
export function clearSession() {
  const opts = { domain: config.cookiedomain, path: "/" };
  cookies.remove("fmw_access_token", opts);
  cookies.remove("fmw_refresh_token", opts);
  cookies.remove("user", opts);
}
